$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  let filterByFromQuery = $('body').attr('filter_by') || null;
  let startDateFromQuery = $('body').attr('start_date') || null;
  let endDateFromQuery = $('body').attr('end_date') || null;
  let customPeriodFromQuery = $('body').attr('custom_period') || null;
  let prevSelectedPeriodFromQuery =
    $('body').attr('prev_selected_period') || null;

  if (p === 'statistic_vat') {
    let totalVAT0 = 0;
    let totalVAT12 = 0;
    let totalVAT15 = 0;
    let totalVAT25 = 0;
    let exportDateData = [];
    let exportVATData = [];
    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );
    handleCustomerIdChange(getVatPercent);
    handleCustomPeriodChange(getVatPercent);
    handleTopProductGroupChange(getVatPercent);
    handleSupplierIdChange(getVatPercent);
    handleProductGroupChange(getVatPercent);
    handleUserChange(getVatPercent);
    handlePlatformChange(getVatPercent);
    handlePeriodChange(getVatPercent);
    handleDateAndTimeChange(getVatPercent);
    handlePreviousButton(getVatPercent);
    handleNextButton(getVatPercent);
    handleCompareByChange(getVatPercent);
    handleProductChange(getVatPercent);
    handlePaymentChange(getVatPercent);
    handleVatCodeChange(getVatPercent);
    handleLocationChange(getVatPercent);
    handleCustomDayChange(getVatPercent);
    handleProductCategoryChange(getVatPercent);

    $(document).on('click', '#download-statistic-excel', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        url: '/api/v1/private/statistics/download-statistic-excel',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_vat_data: exportVATData,
          export_type: 'VAT',
          total_VAT0: totalVAT0,
          total_VAT12: totalVAT12,
          total_VAT15: totalVAT15,
          total_VAT25: totalVAT25,
        }),
        xhrFields: { responseType: 'blob' }, // receive binary data
        success: function (data) {
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
              const filename = `Statistikk mva klasser (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  },
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            const blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk mva klasser (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;
            link.click();
          }
        },
        error: function () {
          alert('Error generating Excel file');
        },
        complete: function () {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(excel)');
        },
      });
    });

    $(document).on('click', '#download-statistic-pdf', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      var svg = chartComponent.getSVG();

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        var pngData = canvas.toDataURL('image/png'); // base64 PNG

        // Send AJAX after PNG is ready
        $.ajax({
          url: '/api/v1/private/statistics/download-statistic-pdf',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            export_date_data: exportDateData,
            export_vat_data: exportVATData,
            export_type: 'VAT',
            total_VAT0: totalVAT0,
            total_VAT12: totalVAT12,
            total_VAT15: totalVAT15,
            total_VAT25: totalVAT25,
            chart_png: pngData,
          }),
          xhrFields: { responseType: 'blob' },
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk mva klasser (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf',
                    },
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk mva klasser (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert('Error generating PDF');
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
          },
          complete: function () {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
          },
        });
      };

      img.src =
        'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
    });

    function eventLineChart(seriesData, interval = null) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      let categories = seriesData.map((item) => item.name); // Extract dates for x-axis categories
      exportDateData = categories;
      // Prepare the series array
      let series = [
        {
          name: 'MVA 0%',
          data: seriesData.map((item) => parseFloat(item.data[0][0])), // First line of Vipps
          stack: 'MVA 0%',
        },
        {
          name: 'MVA 12%',
          data: seriesData.map((item) => parseFloat(item.data[0][1])), // First line of Kort
          stack: 'MVA 12%',
        },
        {
          name: 'MVA 15%',
          data: seriesData.map((item) => parseFloat(item.data[0][2])), // First line of Terminal
          stack: 'MVA 15%',
        },
        {
          name: 'MVA 25%',
          data: seriesData.map((item) => parseFloat(item.data[0][3])), // First line of Kontanter
          stack: 'MVA 25%',
        },
      ];

      exportVATData = series;
      // Conditionally add last week and last year data if compareBy is not null or "0"
      if (compareBy && compareBy !== '0') {
        // Calculate total values
        const totalMVA0 = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[0][0]),
          0
        );
        const totalMVA0Last = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[1][0]),
          0
        );
        const totalMVA12 = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[0][1]),
          0
        );
        const totalMVA12Last = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[1][1]),
          0
        );
        const totalMVA15 = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[0][2]),
          0
        );
        const totalMVA15Last = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[1][2]),
          0
        );
        const totalMVA25 = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[0][3]),
          0
        );
        const totalMVA25Last = seriesData.reduce(
          (sum, item) => sum + parseFloat(item.data[1][3]),
          0
        );

        series = [
          {
            name: `MVA 0% (${formattedPriceToShowForStatistic(
              totalMVA0
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][0])),
            stack: 'MVA 0%',
          },
          {
            name: `MVA 0% forrige ${getPeriodTranslation(
              compareBy ?? '',
              startDate
            )} (${formattedPriceToShowForStatistic(
              totalMVA0Last
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][0])),
            stack: 'MVA 0%',
          },

          {
            name: `MVA 12% (${formattedPriceToShowForStatistic(
              totalMVA12
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][1])),
            stack: 'MVA 12%',
          },
          {
            name: `MVA 12% forrige ${getPeriodTranslation(
              compareBy ?? '',
              startDate
            )} (${formattedPriceToShowForStatistic(
              totalMVA12Last
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][1])),
            stack: 'MVA 12%',
          },

          {
            name: `MVA 15% (${formattedPriceToShowForStatistic(
              totalMVA15
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][2])),
            stack: 'MVA 15%',
          },
          {
            name: `MVA 15% forrige ${getPeriodTranslation(
              compareBy ?? '',
              startDate
            )} (${formattedPriceToShowForStatistic(
              totalMVA15Last
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][2])),
            stack: 'MVA 15%',
          },

          {
            name: `MVA 25% (${formattedPriceToShowForStatistic(
              totalMVA25
            )}) ${legendText}`,
            data: seriesData.map((item) => parseFloat(item.data[0][3])),
            stack: 'MVA 25%',
          },
          {
            name: `MVA 25% forrige ${getPeriodTranslation(
              compareBy ?? '',
              startDate
            )} (${formattedPriceToShowForStatistic(
              totalMVA25Last
            )}) ${previousLegendText}`,
            data: seriesData.map((item) => parseFloat(item.data[1][3])),
            stack: 'MVA 25%',
          },
        ];
      }

      // Render the chart
      chartComponent = Highcharts.chart('event-line-graph', {
        chart: { type: 'column' },
        title: {
          text: null,
        },
        exporting: { enabled: false },
        plotOptions: {
          series: {
            lineWidth: 2, // Adjust line width as needed
            stacking: 'normal', // Enable stacking of columns in the same group
          },
        },
        xAxis: {
          categories: categories,
          labels: {
            formatter: function () {
              if (customPeriod === 'day') {
                return Highcharts.dateFormat(
                  '%e/%b',
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === 'week') {
                return 'Uke ' + this.value;
              } else if (customPeriod === 'month') {
                return Highcharts.dateFormat(
                  '%B %Y',
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: ' ',
          },
        },
        series: series,
        tooltip: {
          formatter: function () {
            let tooltipText;
            let tooltipDate;
            let tooltipWeek;

            if (this.series.name.includes('uke')) {
              let date = moment(this.x);
              date.subtract(1, 'week');
              tooltipDate = date.valueOf();
            } else if (this.series.name.includes('forrige')) {
              let date = moment(this.x);
              date.subtract(1, 'year');
              tooltipDate = date.valueOf();
            } else {
              tooltipDate = this.x;
            }

            if (this.series.name.includes('uke')) {
              tooltipWeek = parseInt(this.x) - 1;
            } else {
              tooltipWeek = this.x;
            }

            if (startDate.split(' ')[0] == endDate.split(' ')[0]) {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%H:%M, %b %e', tooltipDate) +
                '</b><br/>' +
                this.series.name +
                ' : ' +
                formattedPriceToShowForStatistic(this.y);
            } else if (customPeriod === 'week') {
              tooltipText =
                '<b>' +
                'Uke' +
                ' ' +
                tooltipWeek +
                '</b><br/>' +
                this.series.name +
                ' : ' +
                formattedPriceToShowForStatistic(this.y);
            } else if (customPeriod === 'month') {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%B - %Y', tooltipDate) +
                '</b><br/>' +
                this.series.name +
                ' : ' +
                formattedPriceToShowForStatistic(this.y);
            } else {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%A, %b %e, %Y', tooltipDate) +
                '</b><br/>' +
                this.series.name +
                ' : ' +
                formattedPriceToShowForStatistic(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function toggleCustomDatePicker() {
      let customDatePicker = $('.custom-date-picker');

      if (period === 'custom') {
        customDatePicker.show();
      } else {
        customDatePicker.hide();
      }
    }

    function getVatPercent(
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = 'all',
      userId = null,
      platform = 'all',
      customPeriod,
      topProductGroupUniqueId = 0,
      customerId,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      productCategoryId = 0,
      selectedDay = null
    ) {
      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_vat/search',
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          productCategoryId,
          selectedDay,
        },
      })
        .done(function (data) {
          if (data) {
            $('#key-figure-mva-0').text(
              formattedPriceToShowForStatistic(data.noVatCount)
            );
            $('#key-figure-column-1').attr(
              'data-content',
              parseFloat(data.noVatCount, 3).toString().replace('.', ',')
            );
            $('#key-figure-mva-12').text(
              formattedPriceToShowForStatistic(data.reduceVatCount)
            );
            $('#key-figure-column-2').attr(
              'data-content',
              parseFloat(data.reduceVatCount, 3).toString().replace('.', ',')
            );
            $('#key-figure-mva-15').text(
              formattedPriceToShowForStatistic(data.foodVatCount)
            );
            $('#key-figure-column-3').attr(
              'data-content',
              parseFloat(data.foodVatCount, 3).toString().replace('.', ',')
            );
            $('#key-figure-mva-25').text(
              formattedPriceToShowForStatistic(data.regularVatCount)
            );
            $('#key-figure-column-4').attr(
              'data-content',
              parseFloat(data.regularVatCount, 3).toString().replace('.', ',')
            );
            totalVAT0 = data.noVatCount;
            totalVAT12 = data.reduceVatCount;
            totalVAT15 = data.foodVatCount;
            totalVAT25 = data.regularVatCount;
          } else {
            $('#key-figure-mva-0').text('0');
            $('#key-figure-mva-12').text('0');
            $('#key-figure-mva-15').text('0');
            $('#key-figure-mva-25').text('0');
          }

          if (data.data) {
            eventLineChart(data.data);
          }

          let aTags = $('.statistic-tab-group a');
          aTags.each(function () {
            let oldHref = $(this).attr('href').split('?')[0];
            let newHref =
              oldHref +
              `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
            $(this).prop('href', newHref);
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function getMonthGraph(data) {
      let startDay = moment(startDate);
      let endDay = moment(endDate);
      let monthNumbers = [];

      while (startDay.isBefore(endDay)) {
        let monthNumber = startDay.month() + 1;
        monthNumbers.push(monthNumber);
        startDay.add(1, 'month');
      }
      let seriesData = [];
      $.map(monthNumbers, function (month_number) {
        let found = $.grep(data.currentList, function (item) {
          return item.order_date === month_number.toString();
        });
        let monthNumberToDate =
          moment()
            .startOf('year')
            .add(month_number - 1, 'month')
            .format('YYYY-MM-DD') + ' 00:00';
        let monthData1 = [0, 0, 0, 0];
        let monthData2 = [0, 0, 0, 0];
        let monthData3 = [0, 0, 0, 0];
        if (found && found.length > 0) {
          $.map(found, function (item) {
            monthData1[0] += item.payment_data[0];
            monthData1[1] += item.payment_data[1];
            monthData1[2] += item.payment_data[2];
            monthData1[3] += item.payment_data[3];
          });
        }

        let formatedDate = new Date(monthNumberToDate);
        let timestamp = formatedDate.getTime();
        seriesData.push({
          name: timestamp,
          data: [monthData1, monthData2, monthData3],
        });
      });
      eventLineChart(seriesData);
    }

    getVatPercent(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    toggleCustomDatePicker();
  }
});
